// @ts-strict-ignore
import Link from 'next/link';
import { useDispatch, useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section } from 'src/constants/footfall';
import { followUser } from 'src/modules/user/profile/actions';
import { AttentionContainer } from 'src/modules/user/profile/components/shared/sharedStyles';
import MemberCard from 'src/components/memberCard';
import { LinkButton } from 'styles-js/buttons';
type Props = {
  clickOnCard: (href: string, username: string) => void;
};
export default function Followers({
  clickOnCard
}: Props) {
  const dispatch = useDispatch();
  const {
    profileUser,
    followers
  } = useSelector(({
    pages
  }) => pages.profile);
  const {
    isOwnProfile,
    isUserFollowsEnabled,
    username
  } = profileUser;
  const beTheFirstOneToFollow = () => {
    dispatch(followUser(profileUser.userId, i18n.t('You are now following') + `  ${profileUser.username}`));
    trackFootfallEvent(Event.Clicked, {
      clickMetadata: {
        element: 'first-to-follow',
        section: Section.Followers,
        origin: 'other-profile'
      },
      clickType: 'follow'
    });
  };
  return <>
      {!followers?.length ? <AttentionContainer as={'span'} margin={'15px 0 0;'}>
            {isOwnProfile ? <>
                  {i18n.t('You do not have any followers yet.')}
                  {!isUserFollowsEnabled && <>
                      {i18n.t(' You have selected the option for members not to follow you.')}
                      <Link href="/settings">{i18n.t(' You can change it here.')}</Link>
                    </>}
                </> : <>
                  {i18n.t(`${username} does not have any followers`)}
                  {isUserFollowsEnabled && <>
                      {i18n.t(' yet. Be the first one to ')}
                      <LinkButton onClick={beTheFirstOneToFollow}>
                        {i18n.t('follow')}
                      </LinkButton>{'.'}
                    </>}
                </>}
          </AttentionContainer> : followers?.map(follower => <MemberCard isFollowButton={true} key={follower.username} member={{
      ...follower,
      bio: follower?.bio || `Hi! I'm ${follower.username}`
    }} onClick={clickOnCard} onFollowClick={() => trackFootfallEvent(Event.Clicked, {
      clickMetadata: {
        section: Section.MemberCardProfileFollowers,
        origin: follower.userId === profileUser.userId ? 'own-profile' : 'other-profile'
      },
      clickType: follower.isFollowedByCurrentUser ? 'unfollow' : 'follow'
    })} />)}
    </>;
}